<!-- button appears if there are no records -->
<app-add-reference-card *ngIf="dataSource.data.length == 0" desc="You have no item budget record.">
</app-add-reference-card>
<div class="budget-action">
    <app-button class="budgetBtn" icon="remove" name="Remove budget" type="flat-button" tabindex="0"
        (keypress)="!isReadOnly && removeSelectedRows()" (click)="!isReadOnly && removeSelectedRows()"
        *ngIf="dataSource.data.length > 0 && isRowSelected()">
    </app-button>
</div>
<mat-alert></mat-alert>
<div style="overflow-x: auto;">

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 data-grid-table" *ngIf="dataSource.data.length > 0">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="rowSelection.hasValue() && isAllSelected()"
                    [indeterminate]="rowSelection.hasValue() && !isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox tabindex='0' (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()" (change)="onCheckboxChange($event, row)"
                    [checked]="rowSelection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container *ngFor="let column of columns; let i = index">

            <ng-container *ngIf="i == 0">
                <ng-container [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef>
                        {{column.header}}
                    </th>
                    <td mat-cell *matCellDef="let row;">
                        <div class="item-row-hover" *ngIf="row.hovered && !row.isDeleted && !row.Strikethrough">
                            <a (click)="!isReadOnly && editBudget(row)">
                                <div class="row-button">
                                    <mat-icon title="Edit">edit</mat-icon>
                                    <!-- <span class="tooltip-text">Discard</span> -->
                                </div>
                            </a>
                        </div>
                        <div class="item-row-no" *ngIf="!row.hovered">{{ column.cell(row) }}</div>
                    </td>
                </ng-container>

            </ng-container>
            <ng-container *ngIf="i == 1">
                <ng-container [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef>
                        {{column.header}}
                    </th>
                    <td mat-cell *matCellDef="let row;">
                        <div class="item-row-hover" *ngIf="row.hovered && !row.isDeleted && !row.Strikethrough">
                            <a (click)="!isReadOnly && editBudget(row)">
                                <div class="row-button">
                                    <mat-icon title="Edit">edit</mat-icon>
                                </div>
                            </a>
                        </div>
                        <div class="item-row-no" *ngIf="!row.hovered">{{ column.cell(row) }}</div>
                    </td>
                </ng-container>

            </ng-container>
            <ng-container *ngIf="i > 1">
                <ng-container [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef>
                        {{column.header}}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{column.cell(row)}}
                    </td>
                </ng-container>
            </ng-container>

        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns; let rowIndex = index;" (mouseenter)="row.hovered = true"
            (mouseleave)="row.hovered = false"></tr>
    </table>
        
</div>
<mat-paginator #projPaginator [length]="dataSource.data.length" [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>